import React from "react";
import Card from "../../Node/Card.js";
import PropTypes from "prop-types";

const MainCategoryList = ({ categoryGroups }) => (
  categoryGroups.map(categoryGroup => {
    return categoryGroup.fieldWinnerCategories.length > 0 ? <section key={categoryGroup.id} className="block-views contextual-region block-views-blockwinner-in-category-block-1">
      <div className="container card-container view-winner-in-category">
        {categoryGroup.fieldWinnerCategories.length > 0 ?
          <h2>{categoryGroup.name}</h2> :
          null
        }
        <div className="view-content">
          {categoryGroup.fieldWinnerCategories.map((node) => (
            <Card key={node.id}
                  badge={node.categoryBadge}
                  bestPortal={node.category}
                  imageUrl={node.imageUrl}
                  alias={node.alias}
                  owner={node.owner}
                  title={node.title}
            />
          ))}
        </div>
      </div>
    </section> : null
  })
);

MainCategoryList.propTypes = {
  categoryGroups: PropTypes.array.isRequired,
}

export default MainCategoryList;
